// Telemetrie: meldet jeden Skalier-Vorgang an das eigene Statistik-Backend (/api/events).
// Wer skaliert hat, ermittelt der Server aus dem Microsoft-365-Token – hier wird kein
// Name und keine E-Mail mitgeschickt. Fehler beim Melden stören das Skalieren nie.
import { api, type GetIdToken } from "../stats/api";

export interface UsageEvent {
  sourceType: "sharepoint" | "local" | "single";
  objectName: string;
  images: number;
  titleImages: number;
  errors: number;
  inputBytes: number;
  outputBytes: number;
  durationSeconds: number;
}

export async function logUsage(getIdToken: GetIdToken | null, event: UsageEvent): Promise<void> {
  if (!getIdToken) return; // Lokal-Modus ohne Anmeldung: keine Statistik
  try {
    await api(getIdToken, "/events", {
      method: "POST",
      body: JSON.stringify({ ...event, appBuild: __APP_BUILD__ }),
    });
  } catch (err) {
    console.warn("Statistik konnte nicht gespeichert werden (nicht kritisch):", err);
  }
}
